import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import BigButton from '../components/big-button';
import LeafletMap from '../components/map';
import ApplicationMenu from '../components/menu';
import RideTour from '../components/ride-tour';
import { FEATURES, IS_DEVELOPMENT } from '../constants';
import { loadMarkers } from '../redux/actions';

const MapPageComponent = React.memo(
  ({ appready, match: routeParams, user }) => {
    const dispatch = useDispatch();
    const demo = useSelector(_ => _.demo);
    const [mapParams, setMapParams] = useState(null);
    const [leafletMap, setLeafletMap] = useState(null);

    const mapCreatedHandler = useCallback(
      leafletmap => {
        setLeafletMap(leafletmap);
        dispatch(loadMarkers(user));
      },
      [user, dispatch]
    );

    useEffect(() => {
      if (!mapParams) {
        // la carte n'est pas montée
        // tant que l'on a pas vérifié les parametres de l'URL de react-router
        const { lat, lng, zoom } = routeParams.params;
        const latlng = { lat: +lat, lng: +lng };
        const next = (lat && lng && latlng) || null;
        setMapParams({ latlng: next, zoom: Number(zoom) });
      }
    }, [mapParams, routeParams]);

    // console.log('render page');
    const showRideTour =
      FEATURES.ride_tour && appready && (demo || IS_DEVELOPMENT);

    return (
      <div id="smart-apps-page">
        {showRideTour && <RideTour />}
        {mapParams && (
          <LeafletMap params={mapParams} onCreated={mapCreatedHandler} />
        )}
        {leafletMap && (
          <React.Fragment>
            <ApplicationMenu lmap={leafletMap} />
            <BigButton position="bottomright" />
          </React.Fragment>
        )}
      </div>
    );
  }
);

MapPageComponent.defaultProps = {
  user: null,
};

MapPageComponent.propTypes = {
  appready: PropTypes.bool.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      lat: PropTypes.string,
      lng: PropTypes.string,
      zoom: PropTypes.string,
    }).isRequired,
  }).isRequired,
  user: PropTypes.shape(),
};

MapPageComponent.displayName = 'MapPageComponent';

export default MapPageComponent;
